// Campus photo for /colleges/worcester-polytechnic-institute: CC BY-SA 4.0, by Kenneth C. Zirkel, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ABoynton_Hall%2C_Worcester_Polytechnic_Institute.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/worcester-polytechnic-institute/; credited under the photo.
const photo = {
    "slug": "worcester-polytechnic-institute",
    "alt": "Boynton Hall, the stone clock tower building on the Worcester Polytechnic Institute campus in Worcester, Massachusetts",
    "src": "/colleges/worcester-polytechnic-institute/campus-1600.webp",
    "srcSmall": "/colleges/worcester-polytechnic-institute/campus-800.webp",
    "srcMid": "/colleges/worcester-polytechnic-institute/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/worcester-polytechnic-institute/og.jpg",
    "title": "Boynton Hall, Worcester Polytechnic Institute",
    "author": "Kenneth C. Zirkel",
    "license": "CC BY-SA 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ABoynton_Hall%2C_Worcester_Polytechnic_Institute.jpg",
    "read": "2026-10-02"
};

export default photo;
